module.exports = __webpack_public_path__ + "static/media/page-under-construction.430f6ffd.png";